export const availableLanguages = [
    { name: "English", value: "en" },
    { name: "Russian", value: "ru" },
    { name: "Spanish", value: "es" },
    { name: "Japan", value: "jp" }];